module.exports = __webpack_public_path__ + "img/device-Information_1.e538d76a.png";